<script setup>
import {onMounted, reactive} from 'vue'
import {State, getRoute, go} from '@/paks/vu-app'
import {Device} from '@/paks/mgr-models'

const emit = defineEmits(['input'])

const page = reactive({
    claimId: null,
    properties: {},
    saving: false,
})

onMounted(() => {
    let route = getRoute()
    page.properties = route.meta.view?.properties || {}
    if (State.cache.devices.length == 1) {
        page.claimId = State.cache.devices[0].id
    }
})

async function save() {
    await Device.claim({id: page.claimId})
    if (page.properties.standalone) {
        go()
    } else {
        emit('input')
    }
}
</script>

<template>
    <!-- Fix for Vue 3 not passing title to vu-form (add enclosing div) -->
    <div :class="page.properties.standalone ? 'claim-standalone' : 'claim'">
        <vu-form title="Claim Device" help="/doc/ui/devices/claim.html" :data="page" :save="save">
            <vu-sign
                name="claim-device"
                title="Pair Your Device"
                color="accent"
                class="mb-5"
                >
                <p>Pair your device to be managed. Enter the Device Claim ID that printed on your device or packaging.</p>
            </vu-sign>
            <vu-input v-model="page.claimId" label="Device Claim ID" type="text" class="mt-3" />
            <div class="actions">
                <v-btn color="accent" type="submit" :loading="page.saving">Claim</v-btn>
                <v-btn color="none" @click="emit('input')">Cancel</v-btn>
            </div>
        </vu-form>
    </div>
</template>

<style lang="scss">
.claim-standalone {
    margin-top: 20px;
}
</style>
